import ko from "knockout";
import metaCache from "flow/utils/metaCache";

ko.validation.rules["mustBeChecked"] = {
    validator: function (value: boolean) {
        return value === true;
    },
    message: () => metaCache.translate("FlowHtml.Translations.MustBeChecked")
};

ko.validation.registerExtenders();
